import { Box } from '../../../components/internal';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StackedContainerItems = props => {
  var {
    stacksToDisplay
  } = props;
  var {
    stacksContainerItemsWrapper,
    firstStack,
    secondStack
  } = useMultiStyleConfig('StackedContainer', props);
  var shouldDisplayFirstStack = stacksToDisplay > 0;
  var shouldDisplaySecondStack = stacksToDisplay > 1;
  return /*#__PURE__*/_jsxs(Box, {
    __css: stacksContainerItemsWrapper,
    children: [shouldDisplayFirstStack && /*#__PURE__*/_jsx(Box, {
      __css: firstStack
    }), shouldDisplaySecondStack && /*#__PURE__*/_jsx(Box, {
      __css: secondStack
    })]
  });
};
StackedContainerItems.displayName = 'StackedContainerItems';
//# sourceMappingURL=StackedContainerItems.js.map